import { expressCheckoutWidgetLoadingFinished as expressCheckoutWidgetLoadingFinishedOriginal } from '@wix/bi-logger-payments-data/v2';
import { type expressCheckoutWidgetLoadingFinishedParams as expressCheckoutWidgetLoadingFinishedParamsOriginal } from '@wix/bi-logger-payments-data/v2/types';
import { type Origin } from './types';

export type expressCheckoutWidgetLoadingFinishedParams = expressCheckoutWidgetLoadingFinishedParamsOriginal & {
  origin: Origin;
};

export const expressCheckoutWidgetLoadingFinished: (
  p: expressCheckoutWidgetLoadingFinishedParams,
) => ReturnType<typeof expressCheckoutWidgetLoadingFinishedOriginal> = expressCheckoutWidgetLoadingFinishedOriginal;
